<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Mapping Program Study - Jurusan
        <div class="card-header-actions">
          <CLink href="#" class="card-header-action btn-setting">
            <!-- <a @click="addMapping">
              <CIcon name="cil-plus" />
            </a> -->
          </CLink>
        </div>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol col="4">
            <div class="form-group">
              <label>Tahun</label>
              <year-selector @input="changeYear" v-model="newData.year" />
            </div>
          </CCol>
          <CCol col="4">
            <div class="form-group">
              <label>Jalur Masuk</label>
              <entrance-major
                @input="changeEntrance"
                v-model="newData.entrance_major"
              />
            </div>
          </CCol>
          <CCol col="4">
            <div class="form-group">
              <label>Group</label>
              <study-program-group-selector
                @input="changeGroup"
                v-model="newData.study_program_group"
              />
            </div>
          </CCol>
        </CRow>
        <div style="overflow: inherit">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th width="50px">No</th>
                <th>Jalur masuk</th>
                <th>Group</th>
                <th>Program Studi</th>
                <th width="60px">Pendaftar</th>
                <th width="60px">Keketatan</th>
                <th width="60px">Daya Tampung</th>
                <th width="60px">Nilai Nasional</th>
                <th width="60px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in data.data" :key="k">
                <td>{{ k + 1 }}</td>
                <td>
                  <span v-if="d.entrance_major">{{
                    d.entrance_major.label
                  }}</span>
                </td>
                <td>
                  <span v-if="d.study_program_group"
                    >{{ d.study_program_group.name }}
                  </span>
                </td>
                <td>
                  {{ d.label }}
                  <CBadge color="danger" v-show="d.deleted_at">Dihapus</CBadge>
                </td>
                <td>{{ d.registrar }}</td>
                <td>{{ d.tightness }} %</td>
                <td>{{ d.capacity }}</td>
                <td>{{ d.national_value }}</td>
                <td class="action">
                  <btn-edit @click="doEdit(d.id)" />
                  <btn-delete @click="doDelete(d.id)" v-show="!d.deleted_at" />
                </td>
              </tr>
              <tr class="row-input">
                <td class="center">New</td>
                <td colspan="3">
                  <study-program-selector v-model="newData.study_program" />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="newData.registrar"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="newData.tightness"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="newData.capacity"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    v-model="newData.national_value"
                  />
                </td>
                <td class="row-input-button">
                  <button class="btn btn-success" @click="save">Save</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
      <CCardFooter>
        <!-- <div class="form-check float-left">
          <input class="form-check-input" type="checkbox" id="flexCheckDefault">
          <label class="form-check-label" for="flexCheckDefault">
            Show Deleted
          </label>
        </div> -->
        <content-pagination :paginator="paginate" @change="loadPage" />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import { HTTPAUTH, objectToQuery } from "../../lib/httplib";
import BtnEdit from "../../components/BtnEdit";
import BtnDelete from "../../components/BtnDelete";
import YearSelector from "../../components/YearSelector";
import ContentPagination from "../../components/ContentPagination2";
import EntranceMajor from "../../components/EntranceMajor.vue";
import StudyProgramGroupSelector from "../../components/StudyProgramGroupSelector.vue";
import StudyProgramSelector from "../../components/StudyProgramSelector.vue";
export default {
  components: {
    YearSelector,
    BtnEdit,
    BtnDelete,
    ContentPagination,
    EntranceMajor,
    StudyProgramGroupSelector,
    StudyProgramSelector,
  },
  data() {
    return {
      data: {},
      StudyProgramSelectorta: {},
      paginate: {},
      query: {},
      newData: {},
    };
  },
  created() {
    this.query = this.$route.query;
    if (this.query && this.query.page) {
      this.paginate.page = parseInt(this.query.page);
    }
    this.load();
  },
  methods: {
    loadPage(page) {
      this.query.page = page;
      this.load();
    },
    load() {
      var url = `/api/v1/admin/mapping/study?size=10&${objectToQuery(
        this.query
      )}`;
      HTTPAUTH.get(url).then((res) => {
        this.data = res.data;
        this.paginate = this.data.paginate;
        this.$router
          .push({
            query: {
              ent: this.query && this.query.ent ? this.query.ent : "",
              year: this.query && this.query.year ? this.query.year : "",
              page: this.paginate.page,
              size: this.paginate.size,
              group: this.query && this.query.group ? this.query.group : "",
            },
          })
          .catch(() => {});
      });
    },
    addMapping() {
      this.$router.push({ path: "/mapping/study-program/major/new" });
    },
    changeYear(y) {
      if (!y) {
        delete this.query.year;
        this.load();
        return;
      }
      this.query.year = y.label;
      this.load();
    },
    changeEntrance(e) {
      if (!e) {
        delete this.query.ent;
        this.load();
        return;
      }
      this.query.ent = e.id.toString();
      this.load();
    },
    changeGroup(g) {
      if (!g) {
        delete this.query.group;
        this.load();
        return;
      }
      this.query.group = g.id.toString();
      this.load();
    },
    doEdit(id) {
      this.$router.push({ path: "/mapping/study-program/major/" + id });
    },
    doDelete(id) {
      HTTPAUTH.delete("/api/v1/admin/mapping/study/" + id).then(() => {
        this.load();
      });
    },
    save() {
      if (!(this.newData && this.newData.year)) {
        this.$toasted.error("Silahkan pilih tahun terlebih dahulu").goAway();
        return;
      }
      if (!(this.newData && this.newData.entrance_major)) {
        this.$toasted
          .error("Silahkan pilih jalur masuk terlebih dahulu")
          .goAway();
        return;
      }
      if (!(this.newData && this.newData.study_program_group)) {
        this.$toasted.error("Silahkan pilih group terlebih dahulu").goAway();
        return;
      }
      if (!(this.newData && this.newData.study_program)) {
        this.$toasted.error("Silahkan pilih program studi").goAway();
        return;
      }
      HTTPAUTH.post("/api/v1/admin/mapping/study", this.newData).then(() => {
        this.$toasted.success("Berhasil ditambahkan").goAway();
        this.newData.registrar = 0;
        this.newData.tightness = 0;
        this.newData.national_value = 0;
        this.newData.capacity = 0;
        this.newData.study_program = null;
        this.load();
      });
    },
  },
};
</script>